import { motion } from 'framer-motion';
import { CheckCircle2, Cog } from 'lucide-react';

const bullets = [
  'Creá fixtures automáticos para torneos de cualquier formato.',
  'Publicá resultados y posiciones al instante desde cualquier dispositivo.',
  'Compartí horarios, sedes y cambios en tiempo real con todos los equipos.',
];

export function FeatureSection() {
  return (
    <section
      id="funcionalidades"
      className="scroll-mt-24 border-b border-brand-border px-4 py-8 sm:px-6 lg:px-8"
    >
      <div className="mx-auto grid w-full max-w-6xl gap-5 lg:grid-cols-2">
        <motion.article
          initial={{ opacity: 0, x: -20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.45 }}
          className="panel"
        >
          <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-brand-border bg-black/50 px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.16em] text-brand-yellow">
            <Cog size={14} />
            Automatización
          </div>
          <h2 className="font-display text-3xl font-bold leading-tight sm:text-4xl">Gestión de Fixtures</h2>
          <p className="mt-4 text-sm text-zinc-300">
            Generá calendarios completos en segundos con visualización clara por fecha y categoría.
          </p>

          <ul className="mt-6 space-y-3">
            {bullets.map((item) => (
              <li key={item} className="flex items-start gap-2.5 text-sm text-zinc-200">
                <CheckCircle2 size={18} className="mt-0.5 shrink-0 text-brand-yellow" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </motion.article>

        <motion.article
          initial={{ opacity: 0, x: 20 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.25 }}
          transition={{ duration: 0.45 }}
          className="panel flex min-h-0 flex-col justify-center overflow-hidden p-4 sm:p-5"
        >
          <img
            src={`${process.env.PUBLIC_URL}/fixture-protorneos.svg`}
            alt="Calendario de partidos en Protorneos"
            className="mx-auto block h-auto w-full max-w-[658px] object-contain"
            width={658}
            height={316}
            loading="lazy"
            decoding="async"
          />
        </motion.article>
      </div>
    </section>
  );
}
